import React from 'react';
import { useMediaQuery } from '../../hooks/useMediaQuery';
import { PortfolioMobile } from './PortfolioMobile';
import { PortfolioDesktop } from './PortfolioDesktop';

interface PortfolioProps {
  uid: string;
  onAnalyzeTicker: (ticker: string) => void;
}

export function Portfolio({ uid, onAnalyzeTicker }: PortfolioProps) {
  const isMobile = useMediaQuery('(max-width: 768px)');
  
  return isMobile
    ? <PortfolioMobile uid={uid} onAnalyzeTicker={onAnalyzeTicker} />
    : <PortfolioDesktop uid={uid} onAnalyzeTicker={onAnalyzeTicker} />;
}
